import { Text, type TextProps } from '#app/components/Primitives/Text.js';
import { useEffect } from 'react';

type CharacterCounterProps = TextProps & {
  /**
   * The maximum characters allowed (inclusive).
   */
  readonly max: number;
  /**
   * Minimum characters allowed (inclusive).
   */
  readonly min?: number;
  /**
   * The function that get's called on update to verify validity.
   * Returns `true` if in invalid range. Otherwise returns `true`.
   */
  readonly onCheck?: (invalid: boolean) => void;
  /**
   * Whether the `value` should be trimmed of whitespace before checking count.
   */
  readonly trim?: boolean;
  /**
   * The string value to check.
   */
  readonly value: string;
};

export const CharacterCounter = ({
  color,
  max,
  min,
  onCheck,
  trim = true,
  value,
  ...styleProps
}: CharacterCounterProps) => {
  const characterCount: number = trim ? value.trim().length : value.length;
  const validCharacterCount: boolean =
    min === undefined
      ? characterCount > max
      : characterCount > max || characterCount < min;

  useEffect(() => {
    onCheck?.(validCharacterCount);
  }, [onCheck, validCharacterCount]);

  return (
    <Text
      as="span"
      color={color as string}
      {...styleProps}
    >{`${characterCount}/${max}`}</Text>
  );
};
